import { render, staticRenderFns } from "./BirinciSatisForm.vue?vue&type=template&id=6e69d811"
import script from "./BirinciSatisForm.vue?vue&type=script&lang=ts"
export * from "./BirinciSatisForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports